import { IBetaPhaseSystemField } from './beta-manager-api.types';
import { IFieldRenderParams } from 'modules/additional-info-common/fields/fields.types';
import { FIELD_VIEW_TYPES } from 'modules/additional-info-common/additional-info.constants';

const getFieldValue = (fieldDefinition: IBetaPhaseSystemField): string | string[] | null => {
    if (fieldDefinition.Value) {
        if (Array.isArray(fieldDefinition.Value.split(','))) {
            return fieldDefinition.Value.split(',');
        } else {
            return fieldDefinition.Value;
        }
    }
    return null;
};

const getFieldType = (fieldDefinition: IBetaPhaseSystemField): FIELD_VIEW_TYPES => {
    if (fieldDefinition.Value && Array.isArray(fieldDefinition.Value.split(','))) {
        return FIELD_VIEW_TYPES.DROPDOWN;
    }

    return FIELD_VIEW_TYPES.STRING;
};

export const betaCustomFieldsAdapter = (customFields: IBetaPhaseSystemField[]): IFieldRenderParams[] => {
    return customFields
        .filter(field => field.UsedForPlayerRegistration)
        .sort((a, b) => a.OrderNumber - b.OrderNumber)
        .map(field => {
            const fieldValue = getFieldValue(field);
            const fieldType = getFieldType(field);
            return {
                name: field.Name,
                value: fieldValue,
                defaultValue: field.DefaultValue,
                isRequired: field.IsMandatory,
                type: fieldType,
            };
        });
};
